import React, { useCallback } from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { SEND_SAP_INVOICE_B2C_RECORDS_CGST_CGST, SEND_SAP_INVOICE_B2C_RECORDS_IGST } from 'actions/sap';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import { toast } from 'react-toastify';

const SapPosting = ({ month, countPagination }) => {
  const dispatch = useDispatch();

  const buttonStyle = {
    height: '64px',
    fontSize: '1rem',
    fontWeight: '500',
    backgroundColor: '#0a192f',
    borderColor: '#334155',
    color: 'white',
    width: '100%',
  };

  const sendSAPInvoiceB2CRecordsCGSTSGST = useCallback((data, pageIndex) => {
    dispatch({
      type: SEND_SAP_INVOICE_B2C_RECORDS_CGST_CGST.REQUEST,
      payload: {
        ...data,
        page: pageIndex,
      },
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          toast.success("Batch sent successfully");
        }
      },
    });
  }, []);

  const sendSAPInvoiceB2CRecordsIGST = useCallback((data) => {
    dispatch({
      type: SEND_SAP_INVOICE_B2C_RECORDS_IGST.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          toast.success(res?.data?.message);
        }
      },
    });
  }, []);

  return (
    <div className='sap-posting-wrapper'>
      <h5 className='sap-posting-note'>Each batch will send 200 records.</h5>
    <Container>
      <Row className="sap-posting-btn">
        {countPagination?.totalPages > 0 ? (
          Array.from({ length: countPagination.totalPages }, (_, index) => (
            <Button
              key={`cgst-sgst-${index}`}
              variant="outline-secondary"
              style={buttonStyle}
              onClick={() => sendSAPInvoiceB2CRecordsCGSTSGST({ month }, index + 1)}
            >
              {`EEAAS (SGST + CGST) Batch ${index + 1}`}
            </Button>
          ))
        ) : (
          <Button
            variant="outline-secondary"
            style={buttonStyle}
            onClick={() => sendSAPInvoiceB2CRecordsIGST({ month }, 1)} // Default to page 1
          >
            EAAS (IGST)
          </Button>
        )}
        <Button
          variant="outline-secondary"
          style={buttonStyle}
          onClick={() => sendSAPInvoiceB2CRecordsIGST({ month })}
        >
          EAAS (IGST)
        </Button>
      </Row>
    </Container>
    </div>
  );
};

SapPosting.propTypes = {
  month: PropTypes.string,
  countPagination: PropTypes.object,
};

export default SapPosting;